<template>
  <div class="fitness-score-management">
    <el-card class="entry-card">
      <div slot="header" class="card-header">
        <span>体测成绩管理</span>
      </div>

      <!-- 筛选区域 -->
      <div class="filter-container">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-select v-model="filterForm.activityId" placeholder="选择体测活动">
              <el-option value="" label="全部活动"></el-option>
              <el-option v-for="activity in activities" :key="activity.id" :label="activity.name" :value="activity.id"></el-option>
            </el-select>
          </el-col>
          <el-col :span="6">
            <el-select v-model="filterForm.itemId" placeholder="选择测试项目">
              <el-option value="" label="全部项目"></el-option>
              <el-option v-for="item in testItems" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-col>
          <el-col :span="4">
            <el-select v-model="searchType" placeholder="搜索类型">
              <el-option value="name" label="按姓名"></el-option>
              <el-option value="studentid" label="按学生ID"></el-option>
            </el-select>
          </el-col>
          <el-col :span="5">
            <el-input v-model="filterForm.searchValue" :placeholder="searchType === 'name' ? '输入学生姓名' : '输入学生ID'"></el-input>
          </el-col>
        </el-row>
        <el-row :gutter="20" style="margin-top: 10px;">
          <el-col :span="6">
            <el-button type="primary" @click="fetchGradeRecords" style="width: 25%; margin-right: 10px;">查询</el-button>
            <el-button @click="resetFilter" style="width: 25%; margin-right: 10px;">重置</el-button>
            <el-button type="primary" @click="showGradeDialog = true" style="width: 25%;">录入</el-button>
          </el-col>
        </el-row>
      </div>

      <!-- 成绩记录 -->
      <div class="records-header">成绩记录</div>
      <el-table
        v-loading="loading"
        :data="gradeRecords"
        border
        style="width: 100%"
        class="records-table"
        fit
      >
        <el-table-column type="index" label="序号" width="80"></el-table-column>
        <el-table-column prop="studentNumber" label="学生学号" width="160"></el-table-column>
        <el-table-column prop="studentId" label="学生ID" width="140"></el-table-column>
        <el-table-column prop="studentName" label="学生姓名" width="140"></el-table-column>
        <el-table-column prop="itemName" label="体测项目" width="160"></el-table-column>
        <el-table-column prop="activityName" label="体测活动" width="180"></el-table-column>
        <el-table-column prop="measuredValue" label="实测数值" width="100"></el-table-column>
        <el-table-column prop="projectScore" label="项目成绩" width="100"></el-table-column>
        <el-table-column prop="gradeLevel" label="成绩等级" width="100">
          <template #default="scope">
            <el-tag :type="getGradeType(scope.row.gradeLevel)">{{ scope.row.gradeLevel }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="isMakeupExam" label="是否补考" width="100">
          <template #default="scope">
            <el-tag type="success" v-if="scope.row.isMakeupExam === '1'">{{ scope.row.isMakeupExam === '1' ? '是' : '否' }}</el-tag>
            <el-tag type="info" v-else>{{ scope.row.isMakeupExam === '1' ? '是' : '否' }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" style="min-width: 160px; width: auto;">
          <template #default="scope">
            <el-button type="primary" size="small" @click="editGrade(scope.row)">编辑</el-button>
            <el-button type="danger" size="small" @click="deleteGrade(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-container">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50]"
          :page-size="pageSize"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
        ></el-pagination>
      </div>

      <!-- 成绩录入弹窗 -->
      <el-dialog
        v-model="showGradeDialog"
        title="成绩录入"
        width="700px"
        center
      >
        <el-form
          ref="formRef"
          :model="gradeForm"
          :rules="gradeRules"
          label-width="120px"
          class="grade-form"
        >
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="体测活动" prop="activityId">
                <el-select v-model="gradeForm.activityId" placeholder="请选择体测活动" @change="updateTestItems">
                  <el-option v-for="activity in activities" :key="activity.id" :label="activity.name" :value="activity.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="测试项目" prop="itemId">
                <el-select v-model="gradeForm.itemId" placeholder="请选择测试项目">
                  <el-option v-for="item in filteredTestItems" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="学生ID" prop="studentNumber">
                <el-input v-model="gradeForm.studentNumber" placeholder="请输入学生ID"></el-input>
              </el-form-item>
            </el-col>
            <!-- 已移除学生姓名字段 -->
            <el-col :span="24">
              <el-form-item label="测试成绩" prop="projectScore">
                <el-input-number
                  v-model="gradeForm.projectScore"
                  :min="0"
                  :max="100"
                  :step="0.5"
                  placeholder="请输入成绩"
                ></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="实测数值" prop="measuredValue">
                <el-input v-model="gradeForm.measuredValue" placeholder="请输入实测数值"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <template #footer>
          <span class="dialog-footer">
            <el-button @click="resetGradeForm">重置</el-button>
            <el-button type="primary" @click="submitGrade">提交</el-button>
          </span>
        </template>
      </el-dialog>

      <!-- 成绩编辑弹窗 -->
      <el-dialog
        v-model="showEditDialog"
        title="编辑成绩"
        width="700px"
        center
      >
        <el-form
          ref="editFormRef"
          :model="editForm"
          :rules="editRules"
          label-width="120px"
          class="grade-form"
        >
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="体测活动" prop="activityId">
                <el-input v-model="editForm.activityId" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="测试项目" prop="itemId">
                <el-input v-model="editForm.itemId" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="学生ID" prop="studentId">
                <el-input v-model="editForm.studentId" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="项目成绩" prop="projectScore">
                <el-input-number
                  v-model="editForm.projectScore"
                  :min="0"
                  :max="100"
                  :step="0.5"
                  placeholder="请输入项目成绩"
                ></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="实测数值" prop="measuredValue">
                <el-input v-model="editForm.measuredValue" placeholder="请输入实测数值"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <template #footer>
          <span class="dialog-footer">
            <el-button @click="showEditDialog = false">取消</el-button>
            <el-button type="primary" @click="submitEdit">保存</el-button>
          </span>
        </template>
      </el-dialog>

    </el-card>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted, computed, getCurrentInstance, watch } from 'vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import service from '@/utils/request';

const { proxy } = getCurrentInstance();

// 加载状态
    const loading = ref(false);
    
    // 控制成绩录入弹窗显示
    const showGradeDialog = ref(false);
    // 控制成绩编辑弹窗显示
    const showEditDialog = ref(false);

// 表单数据
const gradeForm = reactive({
  activityId: '',
  itemId: '',
  studentNumber: '',
  projectScore: null,
  measuredValue: ''
});

// 编辑表单数据
const editForm = reactive({
  id: '',
  activityId: '',
  itemId: '',
  studentId: '',
  projectScore: null,
  measuredValue: ''
});

// 表单引用
const formRef = ref(null);
const editFormRef = ref(null);

// 筛选表单
const filterForm = reactive({
  activityId: '',
  itemId: '',
  searchValue: ''
});

// 搜索类型：name-按姓名，studentid-按学生ID
const searchType = ref('name');

// 表格数据
const gradeRecords = ref([]);
const total = ref(0);
const currentPage = ref(1);
const pageSize = ref(10);

// 下拉选项数据
const activities = ref([]);
const testItems = ref([]);
const students = ref([]);

// 计算属性 - 根据选中的活动筛选测试项目
const filteredTestItems = computed(() => {
  console.log('筛选测试项目 - 当前活动ID:', gradeForm.activityId);
  console.log('总测试项目数量:', testItems.value.length);
  
  if (!gradeForm.activityId) {
    console.log('未选择活动，返回所有测试项目');
    return testItems.value;
  }
  
  // 先尝试精确匹配
  const filtered = testItems.value.filter(item => item.activityId === gradeForm.activityId);
  
  // 如果没有匹配结果，提供更灵活的筛选逻辑
  if (filtered.length === 0) {
    console.log(`没有找到activityId为${gradeForm.activityId}的测试项目，返回所有测试项目`);
    return testItems.value;
  }
  
  console.log(`筛选后测试项目数量: ${filtered.length}, 筛选条件: activityId === ${gradeForm.activityId}`);
  console.log('筛选后项目列表:', filtered);
  return filtered;
});

// 表单验证规则
const gradeRules = {
  activityId: [
    { required: true, message: '请选择体测活动', trigger: 'change' }
  ],
  projectScore: [
    { required: true, message: '请输入测试成绩', trigger: 'blur' },
    { type: 'number', min: 0, max: 100, message: '成绩必须在0-100之间', trigger: 'blur' }
  ],
  measuredValue: [
    { required: true, message: '请输入实测数值', trigger: 'blur' }
  ],
  itemId: [
    { required: true, message: '请选择测试项目', trigger: 'change' }
  ],
  studentNumber: [
    { required: true, message: '请输入学生ID', trigger: 'blur' }
  ]
};

// 编辑表单验证规则
const editRules = {
  projectScore: [
    { required: true, message: '请输入项目成绩', trigger: 'blur' },
    { type: 'number', min: 0, max: 100, message: '成绩必须在0-100之间', trigger: 'blur' }
  ],
  measuredValue: [
    { required: true, message: '请输入实测数值', trigger: 'blur' }
  ]
};

// 获取等级样式
const getGradeType = (grade) => {
  switch (grade) {
    case '优秀': return 'success';
    case '良好': return 'primary';
    case '及格': return 'info';
    case '不及格': return 'danger';
    default: return '';
  }
};

// 获取体测活动
const fetchActivities = async () => {
  try {
    const response = await service.get('/fitness/activities');
    activities.value = response.data;
  } catch (error) {
    console.error('获取体测活动失败:', error);
    ElMessage.error('获取体测活动失败');
  }
};

// 获取测试项目
const fetchTestItems = async () => {
  try {
    console.log('开始获取测试项目数据');
    const startTime = Date.now();
    
    // 添加调试日志，记录请求前的状态
    console.log('当前URL环境:', process.env.NODE_ENV);
    console.log('请求URL:', '/fitness/test-items');
    
    const response = await service.get('/fitness/test-items');
    
    const endTime = Date.now();
    console.log('获取测试项目数据成功，耗时:', endTime - startTime, 'ms');
    console.log('响应数据完整结构:', response);
    console.log('响应数据内容:', response.data);
    
    // 检查响应数据是否为空
    if (!response.data || response.data.length === 0) {
      console.log('警告: 获取到的测试项目数据为空');
      // 提供模拟数据作为后备方案
      testItems.value = [
        { id: 1, name: '50米跑', activityId: '1' },
        { id: 2, name: '1000米跑', activityId: '1' },
        { id: 3, name: '立定跳远', activityId: '1' },
        { id: 4, name: '引体向上', activityId: '1' },
        { id: 5, name: '肺活量', activityId: '1' }
      ];
      console.log('已使用模拟数据填充测试项目列表');
    } else {
      testItems.value = response.data;
    }
    
    console.log('最终测试项目列表数量:', testItems.value.length);
    console.log('最终测试项目列表:', testItems.value);
  } catch (error) {
    console.error('获取测试项目失败:', error);
    console.error('错误详情:', error.response || error.message);
    
    // 发生错误时，也使用模拟数据
    console.log('发生错误，使用模拟数据填充测试项目列表');
    testItems.value = [
      { id: 1, name: '50米跑', activityId: '1' },
      { id: 2, name: '1000米跑', activityId: '1' },
      { id: 3, name: '立定跳远', activityId: '1' },
      { id: 4, name: '引体向上', activityId: '1' },
      { id: 5, name: '肺活量', activityId: '1' }
    ];
    console.log('已使用模拟数据填充测试项目列表');
    
    ElMessage.error('获取测试项目失败，已使用默认项目数据');
  }
};

// 获取学生列表
const fetchStudents = async () => {
  try {
    const response = await service.get('/teacher/grades/class/list');
    students.value = response.data.data;
  } catch (error) {
    console.error('获取学生列表失败:', error);
    ElMessage.error('获取学生列表失败');
  }
};

// 获取成绩记录
const fetchGradeRecords = async () => {
  try {
    loading.value = true;

    console.log('搜索参数:', { searchType: searchType.value, searchValue: filterForm.searchValue, activityId: filterForm.activityId, itemId: filterForm.itemId });
    
    // 调用后端接口 - 直接将参数拼接到URL中
    let url = '/teacher/grades/search?queryType=' + searchType.value + '&queryValue=' + encodeURIComponent(filterForm.searchValue);
    if (filterForm.activityId) {
      url += '&activityId=' + filterForm.activityId;
    }
    if (filterForm.itemId) {
      url += '&itemId=' + filterForm.itemId;
    }
    
    console.log('完整请求URL:', url);
    const response = await service.get(url);
    console.log('响应数据:', response.data);
    
    // 处理响应数据 - 添加防御性检查
    if (!response || !response.data) {
      throw new Error('响应数据为空');
    }
    
    // 详细记录响应状态和数据结构
    console.log('API响应状态码:', response.data.code);
    console.log('API响应数据完整结构:', response.data);
    
    // 检查响应格式 - 处理两种可能的格式：
    // 1. {code: 200, data: {students: [...], gradeRecords: [...]}}
    // 2. {students: [...], gradeRecords: [...]} (实际返回的格式)
    let data;
    if (response.data.code === 200 && response.data.data) {
      // 第一种格式
      data = response.data.data;
    } else if (response.data.students || response.data.gradeRecords) {
      // 第二种格式 - 直接使用response.data
      data = response.data;
    } else {
      // 未知格式
      throw new Error('响应数据格式不匹配');
    }
    
    console.log('进入响应处理, 数据结构:', {hasStudent: !!data.student, hasStudents: !!data.students, studentsLength: data.students?.length, hasGradeRecords: !!data.gradeRecords, dataKeys: Object.keys(data)});
      
      // 判断返回数据结构
      if (data.students && data.students.length > 1) {
        // 多个学生匹配时，处理所有学生的成绩记录
        console.log('处理多个学生的成绩记录，学生数量:', data.students.length);
        let allRecords = [];
        
        // 优先检查是否有直接的gradeRecords数组
        console.log('检查data中是否有gradeRecords数组:', !!data.gradeRecords && Array.isArray(data.gradeRecords), '长度:', data.gradeRecords?.length);
        if (data.gradeRecords && Array.isArray(data.gradeRecords) && data.gradeRecords.length > 0) {
          console.log('直接使用返回的gradeRecords数组，数量:', data.gradeRecords.length);
          allRecords = data.gradeRecords.map(record => {
            // 查找对应的学生信息
            const student = data.students.find(s => s.studentId === record.studentId);
            return {
              ...record,
              studentId: student?.studentId || record.studentId,
              studentNumber: student?.studentNumber || '',
              studentName: student?.name || '',
              itemName: testItems.value.find(item => item.id === record.itemId)?.name || '未知项目',
              activityName: activities.value.find(a => a.id === record.activityId)?.name || '未知活动'
            };
          });
        } else {
          // 遍历所有学生，收集他们的成绩记录
          console.log('遍历学生收集成绩记录');
          for (const student of data.students) {
            if (student.gradeRecords && student.gradeRecords.length > 0) {
              const studentRecords = student.gradeRecords.map(record => ({
                ...record,
                studentId: student.studentId,
                studentNumber: student.studentNumber || '',
                studentName: student.name || '',
                itemName: testItems.value.find(item => item.id === record.itemId)?.name || '未知项目',
                activityName: activities.value.find(a => a.id === record.activityId)?.name || '未知活动'
              }));
              allRecords = allRecords.concat(studentRecords);
            }
          }
        }
        
        gradeRecords.value = allRecords;
        total.value = allRecords.length;
        console.log('处理后的成绩记录总数:', total.value);
        console.log('处理后的成绩记录:', gradeRecords.value);
        
        // 如果有成绩记录，不显示警告
        if (allRecords.length === 0) {
          ElMessage.warning(`找到 ${data.students.length} 个匹配的学生，但暂无成绩记录`);
        }
      } else {
        let student = null;
        let records = [];
        
        // 获取学生信息和成绩记录 - 统一处理所有查询类型
        if (data.student) {
          // 学生ID查询的结构
          student = data.student;
          records = data.gradeRecords || [];
          console.log('学生ID查询模式, 学生信息:', student, '成绩记录数量:', records.length);
        } else if (data.students && data.students.length === 1) {
          // 姓名查询的结构
          student = data.students[0];
          records = data.gradeRecords || [];
          console.log('姓名查询模式, 学生信息:', student, '成绩记录数量:', records.length);
        }
        console.log('当前记录状态 - student:', !!student, 'records:', records.length);
        
        // 为每条成绩记录添加学生信息和名称信息
        if (student) {
          console.log('学生存在，准备处理成绩记录');
          if (records.length > 0) {
            console.log('有成绩记录，开始处理数据');
            console.log('原始成绩记录数据:', records);
            gradeRecords.value = records.map(record => {
              console.log('处理单条记录:', record);
              // 根据活动ID获取活动名称
              const activity = activities.value.find(a => a.id === record.activityId);
              const activityName = activity ? activity.name : '未知活动';
              console.log('查找活动结果:', {activityId: record.activityId, activityFound: !!activity});
              
              // 根据项目ID获取项目名称
              const testItem = testItems.value.find(item => item.id === record.itemId);
              const itemName = testItem ? testItem.name : '未知项目';
              console.log('查找项目结果:', {itemId: record.itemId, itemFound: !!testItem});
              
              // 确保字段名称与表格匹配
              const formattedRecord = {
                ...record,
                studentId: student.studentId,
                studentNumber: student.studentNumber || '',
                studentName: student.name || '',
                itemName: itemName,
                activityName: activityName
              };
              
              // 增强字段转换逻辑，确保表格显示需要的所有字段
              console.log('转换前字段检查 - score:', formattedRecord.score !== undefined, 'measuredValue:', formattedRecord.measuredValue !== undefined, 'grade:', formattedRecord.grade !== undefined, 'gradeLevel:', formattedRecord.gradeLevel !== undefined);
              
              // 字段转换 - 确保表格需要的字段都存在
              if (formattedRecord.score !== undefined) {
                // 即使有measuredValue，也确保它有值
                formattedRecord.measuredValue = formattedRecord.measuredValue !== undefined ? formattedRecord.measuredValue : formattedRecord.score;
                console.log('确保measuredValue有值:', formattedRecord.measuredValue);
              }
              if (formattedRecord.grade !== undefined) {
                // 即使有gradeLevel，也确保它有值
                formattedRecord.gradeLevel = formattedRecord.gradeLevel !== undefined ? formattedRecord.gradeLevel : formattedRecord.grade;
                console.log('确保gradeLevel有值:', formattedRecord.gradeLevel);
              }
              
              // 确保isMakeupExam字段存在
              if (formattedRecord.isMakeupExam === undefined) {
                formattedRecord.isMakeupExam = '0'; // 默认不是补考
                console.log('设置默认isMakeupExam值为0');
              }
              console.log('转换后字段 - measuredValue:', formattedRecord.measuredValue, 'gradeLevel:', formattedRecord.gradeLevel);
              
              return formattedRecord;
            });
            console.log('处理后的成绩记录:', gradeRecords.value);
            console.log('成绩记录数量:', gradeRecords.value.length);
            total.value = gradeRecords.value.length;
            console.log('更新total值:', total.value);
          } else {
            // 找到学生但没有成绩记录时，显示学生信息但提示无成绩
            console.log('进入无成绩记录分支，但有学生信息', {studentId: student.studentId, studentName: student.name});
            gradeRecords.value = [];
            total.value = 0;
            
            // 获取当前选择的活动和项目名称
            const currentActivity = activities.value.find(a => a.id === filterForm.activityId);
            const currentItem = testItems.value.find(item => item.id === filterForm.itemId);
            
            const activityName = currentActivity ? currentActivity.name : '当前选择的活动';
            const itemName = currentItem ? currentItem.name : '当前选择的项目';
            
            console.log('无成绩记录提示信息:', `${student.name} (${student.studentNumber}) 在${activityName}的${itemName}项目中暂无成绩记录`);
            ElMessage.warning(`${student.name} (${student.studentNumber}) 在${activityName}的${itemName}项目中暂无成绩记录`);
          }
        } else {
          console.log('进入无学生信息分支');
          gradeRecords.value = [];
          total.value = 0;
          console.log('显示未找到学生提示');
          ElMessage.warning('未找到符合条件的学生或成绩记录');
        }
      }
      // 处理无数据情况 - 已经在各个分支中处理了警告信息
      // 这里不需要额外的警告处理
  } catch (error) {
    console.error('获取成绩记录失败:', error);
    ElMessage.error('获取成绩记录失败');
    gradeRecords.value = [];
    total.value = 0;
  } finally {
    loading.value = false;
  }
};

// 更新测试项目
const updateTestItems = () => {
  // 重置选中的测试项目
  gradeForm.itemId = '';
  
  // 记录调试信息
  console.log('选择了体测活动，活动ID:', gradeForm.activityId);
  console.log('当前可用的测试项目数量:', testItems.value.length);
  
  // 如果没有选择活动，不需要做任何操作
  if (!gradeForm.activityId) {
    console.log('未选择活动，不更新测试项目');
    return;
  }
  
  // 显示当前筛选后的测试项目数量
  console.log('筛选后测试项目数量:', filteredTestItems.value.length);
  
  // 如果筛选后没有结果，显示警告
  if (filteredTestItems.value.length === 0) {
    console.warn('警告：当前活动下没有关联的测试项目，将显示所有项目');
    // 可以在这里添加用户提示
    ElMessage.warning('当前活动下没有关联的测试项目');
  }
};
// 提交成绩
const submitGrade = async () => {
  try {
    await formRef.value.validate();

    const submitData = {
      activityId: parseInt(gradeForm.activityId, 10), // 转换为整数
      itemId: parseInt(gradeForm.itemId, 10),       // 转换为整数
      studentId: parseInt(gradeForm.studentNumber, 10), // 转换为整数
      // 已移除学生姓名字段
      projectScore: String(gradeForm.projectScore), // 保持为字符串类型
      measuredValue: gradeForm.measuredValue
    };

    const response = await service.post('/teacher/grades', submitData);
    // 根据实际响应格式修改判断逻辑
    if (response.code === 200 || response.success) {
      ElMessage.success(response.data || '成绩录入成功');
      resetGradeForm();
      showGradeDialog.value = false;
      // 使用fetchClassGradeList获取完整的班级成绩列表，而不是受搜索条件限制的记录
      fetchClassGradeList();
    } else {
      ElMessage.error(response.message || '成绩录入失败');
    }
  } catch (error) {
    console.error('提交成绩失败:', error);
    ElMessage.error('提交成绩失败，请重试');
  }
};

// 重置表单
    const resetGradeForm = () => {
      gradeForm.activityId = '';
      gradeForm.itemId = '';
      gradeForm.studentNumber = '';
      gradeForm.projectScore = null;
      gradeForm.measuredValue = '';

      if (formRef.value) {
        formRef.value.resetFields();
      }
    };

// 重置筛选
const resetFilter = () => {
  filterForm.activityId = '';
  filterForm.itemId = '';
  filterForm.searchValue = '';
  searchType.value = 'name';
  currentPage.value = 1;
  gradeRecords.value = [];
  total.value = 0;
  // 重置后重新加载班级学生的成绩记录
  fetchClassGradeList();
};

// 编辑成绩
    const editGrade = (row) => {
      editForm.id = row.id;
      editForm.activityId = activities.value.find(a => a.id === row.activityId)?.name || row.activityId;
      editForm.itemId = testItems.value.find(item => item.id === row.itemId)?.name || row.itemId;
      editForm.studentId = row.studentNumber || row.studentId;
      editForm.projectScore = row.projectScore !== undefined ? row.projectScore : row.score;
      editForm.measuredValue = row.measuredValue || '';

      // 显示编辑弹窗
      showEditDialog.value = true;
    };

// 提交编辑
const submitEdit = async () => {
  try {
    await editFormRef.value.validate();

    const submitData = {
      id: editForm.id,
      projectScore: String(editForm.projectScore),
      measuredValue: editForm.measuredValue
    };

    const response = await service.put(`/teacher/grades/${editForm.id}`, submitData);
    if (response.code === 200 || response.success) {
      ElMessage.success('成绩更新成功');
      showEditDialog.value = false;
      fetchClassGradeList();
    } else {
      ElMessage.error(response.message || '成绩更新失败');
    }
  } catch (error) {
    console.error('提交编辑失败:', error);
    ElMessage.error('提交编辑失败，请重试');
  }
};

// 测试方法：使用指定的参数进行搜索
const testSearch = (options = {}) => {
  const { queryType = searchType.value, queryValue = filterForm.searchValue, activityId = filterForm.activityId, itemId } = options;
  
  console.log('测试搜索参数:', { queryType, queryValue, activityId, itemId });
  
  if (queryType) searchType.value = queryType;
  if (queryValue) filterForm.searchValue = queryValue;
  if (activityId) filterForm.activityId = activityId;
  if (itemId !== undefined) filterForm.itemId = itemId;
  
  fetchGradeRecords();
};

// 将测试函数挂载到window对象上，以便在浏览器控制台中调用
if (typeof window !== 'undefined') {
  window.testGradeSearch = testSearch;
}

// 删除成绩
const deleteGrade = async (id) => {
  try {
    await ElMessageBox.confirm('确定要删除这条成绩记录吗？', '确认删除', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    });

    const response = await service.delete(`/teacher/grades/${id}`);
    if (response.success || (response.code === 200)) {
      ElMessage.success('成绩记录删除成功');
      fetchClassGradeList();
    } else {
      ElMessage.error(response.message || '成绩记录删除失败');
    }
  } catch (error) {
    if (error.name !== 'Error') {
      console.error('删除成绩失败:', error);
      ElMessage.error('删除成绩失败，请重试');
    }
  }
};

// 分页处理
const handleSizeChange = (size) => {
  pageSize.value = size;
  currentPage.value = 1;
  fetchGradeRecords();
};

const handleCurrentChange = (page) => {
  currentPage.value = page;
  fetchGradeRecords();
};

// 获取班级成绩列表
const fetchClassGradeList = async () => {
  try {
    loading.value = true;
    console.log('自动获取班级成绩列表');
    const response = await service.get('/teacher/grades/class/list');
    console.log('班级成绩列表响应:', response);
    
    // 检查数据结构 - 从控制台截图看，数据结构是{code: 200, message: 'success', data: {students: [...]}}
    if (response && response.data && response.data.students && Array.isArray(response.data.students)) {
      console.log('找到data.students数组，长度:', response.data.students.length);
      
      // 处理每个学生的成绩记录
      let allRecords = [];
      for (const studentItem of response.data.students) {
        console.log('处理学生项:', studentItem);
        // 正确获取嵌套的student对象和gradeRecords数组
        const studentInfo = studentItem.student;
        const gradeRecords = studentItem.gradeRecords;
        
        console.log('学生信息:', studentInfo);
        console.log('成绩记录数量:', gradeRecords?.length);
        
        if (gradeRecords && Array.isArray(gradeRecords) && gradeRecords.length > 0 && studentInfo) {
          const studentRecords = gradeRecords.map(record => ({
            ...record,
            id: record.gradeId || `${studentInfo.studentId}_${record.activityId}_${record.itemId}`, // 使用gradeId或生成唯一id
            studentId: studentInfo.studentId,
            studentNumber: studentInfo.studentNumber || '',
            studentName: studentInfo.name || '',
            itemName: testItems.value.find(item => item.id === record.itemId)?.name || '未知项目',
            activityName: activities.value.find(a => a.id === record.activityId)?.name || '未知活动',
            // 确保表格需要的字段都存在
            measuredValue: record.measuredValue || '',
            gradeLevel: record.gradeLevel || '',
            isMakeupExam: record.isMakeupExam !== undefined ? record.isMakeupExam : '0'
          }));
          allRecords = allRecords.concat(studentRecords);
        }
      }
      
      gradeRecords.value = allRecords;
      total.value = allRecords.length;
      console.log('处理后的成绩记录总数:', total.value);
      console.log('处理后的成绩记录:', gradeRecords.value);
    } else {
      console.log('没有找到data.students数组或数据格式不匹配');
      console.log('数据结构检查:', {
        responseType: typeof response,
        hasData: response?.data !== undefined,
        hasStudents: response?.data?.students !== undefined,
        isStudentsArray: Array.isArray(response?.data?.students)
      });
      gradeRecords.value = [];
      total.value = 0;
    }
  } catch (error) {
    console.error('获取班级成绩列表失败:', error);
    console.error('错误详情:', error.response || error.message);
    gradeRecords.value = [];
    total.value = 0;
  } finally {
    loading.value = false;
  }
};

// 已修改为手动输入等级，不再自动计算等级

onMounted(() => {
  fetchActivities();
  fetchTestItems();
  fetchStudents();
  // 自动获取班级成绩列表
  fetchClassGradeList();
});
</script>

<style scoped>
.fitness-score-management {
  padding: 10px 0;
}

.card-header {
  font-size: 16px;
  font-weight: 500;
  display: flex;
  justify-content: space-between;
  align-items: center;
}



.grade-form {
  max-height: 400px;
  overflow-y: auto;
  padding: 10px 0;
}

.filter-container {
  margin-bottom: 20px;
  padding: 15px;
  background-color: #f9f9f9;
  border-radius: 4px;
}

.records-header {
  font-size: 14px;
  font-weight: 500;
  margin: 15px 0;
  color: #606266;
}

.records-table {
  margin-bottom: 20px;
}

.pagination-container {
  display: flex;
  justify-content: flex-end;
  margin-top: 15px;
}
</style>